export default __webpack_public_path__ + "static/media/gallery - story - pot (1)_01.edbbd5a5.jpg";